import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyTextArea from '../../../components/forms/textArea'
import MyOrganizationCategorySelect from '../../../components/select/organizationCategorySelect'
import MyImageUpload from '../../../components/forms/imageUpload'

const AddAlumniOrganization = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '名称不能为空'})
      return false
    }

    axios.post('/p/alumni/organization/add', {
      merchant_oid: merchantOid,
      organization_oid: formValue.organization_oid,
      category_oid: formValue.category_oid,
      name: formValue.name,
      icon_url: formValue.icon_url,
      sort: Number(formValue.sort),
      description: formValue.description
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('创建成功！')
          props.getOrganizationList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({college_oid: formValue.college_oid})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建组织"
        width='760px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyImageUpload 
          id="icon_url"
          label='图标'
          value={formValue.icon_url}
          setValue={setFormValue}
        />

        <MyInput
          id="name"
          required
          autoFocus
          maxLength={64}
          label='名称'
          placeholder='请输入名称'
          value={formValue.name}
          onChange={setFormValue}
          errorMsg={errorMsg.nameEmpty}
        />

        <MyTextArea
          id="description"
          label='介绍'
          minRows={3}
          placeholder='请输入组织介绍'
          value={formValue.description}
          onChange={setFormValue}
        />

        <MyOrganizationCategorySelect
          id='category_oid'
          label='选择分类'
          value={formValue.category_oid}
          onChange={setFormValue}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Modal>
    </>
  )
}

export default AddAlumniOrganization
